import React, { useState, useEffect } from 'react';
import { styled } from '../../../stitches.config';
import Slider from "react-slick";
import Box from '../Box'

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// icons 
import backgroundDestkop from '../../../assets/img/natemat/lenovo/background-desktop.png'
import backgroundMobile from '../../../assets/img/natemat/lenovo/background-mobile.png'
import { ReactComponent as ArrowLeft } from '../../../assets/img/natemat/lg/strzalka-l.svg?react'
import { ReactComponent as ArrowRight } from '../../../assets/img/natemat/lg/strzalka-p.svg?react'
import article1 from '../../../assets/img/natemat/lenovo/lenovo-1.png';
import article2 from '../../../assets/img/natemat/lenovo/lenovo-2.png';
import article3 from '../../../assets/img/natemat/lenovo/lenovo-3.png';
import article4 from '../../../assets/img/natemat/lenovo/lenovo-4.png';

const Arrow = (props) => {
    const { className, style, onClick, icon } = props;
    return (
        <CustomArrow
            className={className}
            style={{ ...style, display: "flex" }}
            onClick={onClick}
        >
            {icon}
        </CustomArrow>
    );
}

const config = {
    settings: {
        b1: {
            title: "A jednak! Sprawdź, co oferują komputery z serii Lenovo Yoga",
            description: "Laptop idealny nie istn...",
            img: article1,
            link: "https://natemat.pl/413251,sprawdzamy-co-potrafia-nowe-laptopy-lenovo-yoga-slim-7i-pro",
        },
        b2: {
            title: "Laptop od Lenovo potrafi coś, czego nie próbował żaden inny",
            description: "Tak wygląda zaskoczenie.",
            img: article2,
            link: "https://innpoland.pl/180655,lenovo-thinkpad-x1-fold-pierwszy-skladany-laptop",
        },
        b3: {
            title: "I wcale nie chodzi o ochronę przed wirusami czy hakerami",
            description: "Tak zwiększysz bezpieczeństwo komputera",
            img: article3,
            link: "https://natemat.pl/409888,laptopy-lenovo-thinkbook-ubezpieczenie-adp-na-komputery-przenosne",
        },
        b4: {
            title: "Poznaj wydajne ThinkPady",
            description: "Wszechstronność bez kompromisów.",
            img: article4,
            link: "https://natemat.pl/413254,poznaj-nowe-laptopy-lenovo-thinkpad-komputery-do-zadan-specjalnych",
        },
    }
}

const { settings: { b1, b2, b3, ...desktopConfig } } = config
console.log({ desktopConfig })

const shuffleCards = (number) => (cards) => {
    const array = Object.keys(cards).map(k => cards[k]);
    let currentIndex = array.length, randomIndex;

    while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
    const obj = array.reduce((acc, curr, i) => (acc[`b${i + number}`] = curr, acc), {})

    return obj
}

const shuffleCardsDesktop = shuffleCards(4)
const shuffleCardsMobile = shuffleCards(1)

export default props => {
    const [desktopCards] = useState(() => shuffleCardsDesktop(desktopConfig))
    const [mobileCards] = useState(() => shuffleCardsMobile(config.settings))
    useEffect(() => {
        console.log({ desktopCards, mobileCards })
    })
    const settings = {
        infinite: true,
        dots: true,
        arrows: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: <Arrow icon={<ArrowLeft />} />,
        nextArrow: <Arrow icon={<ArrowRight />} />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    centerMode: true,
                    infinite: true,
                    arrows: true,
                    dots: true,
                    prevArrow: <Arrow icon={<ArrowLeft />} />,
                    nextArrow: <Arrow icon={<ArrowRight />} />,
                    centerPadding: "45px",
                }
            },
            {
                breakpoint: 875,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    infinite: true,
                    arrows: true,
                    dots: true,
                    prevArrow: <Arrow icon={<ArrowLeft />} />,
                    nextArrow: <Arrow icon={<ArrowRight />} />,
                    centerPadding: "45px",
                }
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: true,
                    arrows: true,
                    dots: true,
                    prevArrow: <Arrow icon={<ArrowLeft />} />,
                    nextArrow: <Arrow icon={<ArrowRight />} />,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: true,
                    arrows: true,
                    dots: true,
                    prevArrow: <Arrow icon={<ArrowLeft />} />,
                    nextArrow: <Arrow icon={<ArrowRight />} />,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: true,
                    arrows: true,
                    dots: true,
                    prevArrow: <Arrow icon={<ArrowLeft />} />,
                    nextArrow: <Arrow icon={<ArrowRight />} />,
                    centerPadding: "30px",
                }
            }
        ]
    };
    return (
        <Wrapper>
            {window.innerWidth > 922 ?
                <CarouselWrapper>
                    <Slider {...settings}>
                        <Box {...props}
                            id="b1"
                            type="ASpecialLG"
                            settings={b1}
                        />
                        <Box {...props}
                            id="b2"
                            type="ASpecialLG"
                            settings={b2}
                        />
                        <Box {...props}
                            id="b3"
                            type="ASpecialLG"
                            settings={b3}
                        />
                        <Box {...props}
                            id="b4"
                            type="ASpecialLG"
                            settings={desktopCards.b4}
                        />
                    </Slider>
                </CarouselWrapper> :
                <>
                    <CarouselWrapper>
                        <Slider {...settings}>
                            <Box {...props}
                                id="b1"
                                type="ASpecialLG"
                                settings={mobileCards.b1}
                            />
                            <Box {...props}
                                id="b2"
                                type="ASpecialLG"
                                settings={mobileCards.b2}
                            />
                            <Box {...props}
                                id="b3"
                                type="ASpecialLG"
                                settings={mobileCards.b3}
                            />
                            <Box {...props}
                                id="b4"
                                type="ASpecialLG"
                                settings={mobileCards.b4}
                            />
                        </Slider>
                    </CarouselWrapper>
                </>}
        </Wrapper>
    );
}

const CustomArrow = styled("div", {
    height: "100%",
    width: "38px",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.5)"
    },
    "svg": {
        width: "26px",
        height: "26px",
        margin: "auto",
        ".cls-2": {
            transition: "stroke ease-out 300ms"
        },
        "&:hover": {
            ".cls-2": {
                stroke: "$primary",
                transition: "stroke ease-out 300ms"
            }
        }
    }
});

const CarouselWrapper = styled("div", {
    marginBottom: "55px",
    overflow: "visible",
    ".slick-list": {
        overflow: "visible"
    },
    ".slick-slide": {
        "& > div": {
            display: "grid",
            placeItems: "center"
        }
    },
    ".slick-arrow": {
        zIndex: 10
    },
    ".slick-prev": {
        left: "0",
        "svg": {
            marginLeft: "10px"
        }
    },
    ".slick-next": {
        right: "0", "svg": {
            marginRight: "10px"
        }
    },
    ".slick-arrow:before": {
        display: "none"
    },
    ".slick-dots": {
        bottom: "-35px",
        "li": {
            margin: "0",
            width: "18px",
            height: "9px",
            "&.slick-active": {
                button: {
                    "&:before": {
                        color: "#e11409",
                        "@media only screen and (min-width: 992px)": {
                            border: "0.5px solid white",
                            borderRadius: "10px"
                        }
                    }
                }
            },
            "button": {
                width: "9px",
                height: "9px",
                padding: "0",
                "&:before": {
                    width: "9px",
                    height: "9px",
                    fontSize: "9px",
                    lineHeight: "9px",
                    color: "white",
                    opacity: 1,
                    "@media only screen and (min-width: 992px)": {
                        border: "0.5px solid #e11409",
                        borderRadius: "10px"
                    }
                }
            }
        }
    }
});

const Wrapper = styled("div", {
    overflow: "hidden",
    width: "100%",
    borderRadius: "15px",
    backgroundImage: `url("${backgroundMobile}")`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    marginTop: "20px",
    marginBottom: "10px",
    paddingBottom: "1px",
    paddingTop: "152px",
    "@media only screen and (min-width: 992px)": {
        backgroundImage: `url("${backgroundDestkop}")`,
        backgroundPosition: "center",
        backgroundSize: "contain",
        position: "relative",
        borderRadius: "15px",
        marginTop: "10px",
        paddingTop: "127px"
    }
});
